<div class="modal-header">
  <h4 class="modal-title">Change Branch</h4>
  <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="close()" aria-label="Close"></button>
</div>
<div class="modal-body">
  <p class="mb-1">Change branch of {{ company.CompanyCode }} from</p>
  <div class="card p-3 border-0 shadow d-grid gap-1 mb-1">
    <h5>{{ currentBranch.BusinessName }}</h5>
  @if (currentBranch.Name) {
    <h5>{{ currentBranch.Name }}</h5>
  }
    <div>{{ activeLicense.FullAddress }}</div>
    <div>+{{ activeLicense.ContactNo }}</div>
  @if (activeLicense.Email) {
    <div>{{ activeLicense.Email }}</div>
  }
  </div>
  <p class="mb-1">to: {{ branchId() }}</p>
  <app-select-business-license [(businessId)]="businessId" [(branchId)]="branchId" [lockSelection]="lockSelection" [displayBranchOnly]="false"></app-select-business-license>
    <p class="mb-0 mt-2">
    @if (currentBranch.Id === branchId()) {
      You have selected current branch, no changes needed!
    } @else {
      Are you sure to change branch of {{ company.CompanyCode }}?
    }
  </p>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-success" (click)="changeBranch()" [disabled]="branchId() === undefined || businessId() === undefined || currentBranch.Id === branchId()">Confirm</button>
  <button class="btn btn-outline-danger" (click)="close()">Cancel</button>
</div>